export interface AmenityAttribute {
  name: string;
  content: string;
  contentType: "price" | "number" | "text";
}

export interface Amenity {
  id: string;
  slug: string;
  status: "not-included" | "included" | "charged";
  name: string;
  description?: string;
  attributes: AmenityAttribute[];
  externalId: string;
}

export interface AmenityGroup {
  name: string;
  amenities: Amenity[];
}

export interface AmenitiesData {
  amenities: AmenityGroup[];
}

export interface FormAmenityOutput {
  amenityId: string;
  status: "not-included" | "included" | "charged";
  attributes?: Record<string, string>;
}

export interface BackendAmenityOutput {
  id?: string;
  privateRoomId?: string;
  amenityId: string;
  privateRoomAttributeId?: string | null;
  isInternalAmenity: boolean;
  isInternalAttribute: boolean;
}

export const CATEGORY_NAMES: Record<string, string> = {
  entranceAndAccess: "Acesso e segurança",
  accessibility: "Acessibilidade",
  environmentAndClimateControl: "Estrutura da sala",
  supportServices: "Serviços do espaço",
  structureAndOffice: "Conforto e utilidades",
  parkingAndTransportation: "Estacionamento e transporte",
  technologyAndConnectivity: "Conectividade",
  receptionAndSecurity: "Recepção e segurança",
};
